import { atom, selector, selectorFamily, useRecoilState } from 'recoil'
import { IProfit } from '../types/types'
import { api } from '../utils/api'

export const fetchProfits = async (): Promise<IProfit[]> => {
  const { data } = await api.get('/profits')
  return data.profits
}

export const profitsState = atom<IProfit[]>({
  key: 'profitsState',
  default: selector({
    key: 'profitsState/Default',
    get: async (): Promise<IProfit[]> => fetchProfits(),
  }),
})

/**
 * Add a new deposit to the list of profits
 */
export const useAddProfit = () => {
  const [profits, setProfits] = useRecoilState(profitsState)

  const addProfit = (deposit: IProfit) => {
    setProfits([...profits, deposit])
  }

  return addProfit
}

export const useDeleteProfit = () => {
  const [profits, setProfits] = useRecoilState(profitsState)

  const deleteProfit = async (profitId: string) => {
    const response = await api.delete(`/profit/${profitId}`)

    if (response.status === 200) {
      setProfits(profits.filter((item) => item.id !== profitId))
    }
  }

  return deleteProfit
}

export const profitState = selectorFamily<IProfit | null, string>({
  key: 'profitState',
  get:
    (id: string) =>
    async ({ get }) => {
      return get(profitsState).find((item) => item.id === id) || null
    },
})